import { render } from "./UploadRosterDialog.vue?vue&type=template&id=252e0e98"
import script from "./UploadRosterDialog.vue?vue&type=script&lang=js"
export * from "./UploadRosterDialog.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "252e0e98"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('252e0e98', script)) {
    api.reload('252e0e98', script)
  }
  
  module.hot.accept("./UploadRosterDialog.vue?vue&type=template&id=252e0e98", () => {
    api.rerender('252e0e98', render)
  })

}

script.__file = "src/components/roster/UploadRosterDialog.vue"

export default script